/**
 * Full-page loading spinner — displayed during page transitions
 * while data is loading. Replaces skeleton loaders with a clean
 * centered spinning circle.
 */
export default function PageSpinner() {
  return (
    <div className="page-spinner" role="status" aria-busy="true" aria-label="Loading">
      <div className="page-spinner-ring" />
    </div>
  );
}
